import {ILoggerService} from "./logger.service.interface";

export class ConsoleLoggerService implements ILoggerService {

    debug(message: string, details?: any): void {
        console.debug(message, details);
    }

    info(message: string, details?: any): void {
        console.info(message, details);
    }

    warning(message: string, details?: any): void {
        console.warn(message, details);
    }

    error(message: string, details?: any): void {
        console.error(message, details);
    }

}
